import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="px-4 py-10 md:px-6 md:py-16">
        <div className="mx-auto grid max-w-page grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5 text-xs text-accent-700 md:text-sm">
              <i className="ri-bookmark-3-line" />
              入口汇总 · 持续校对于 2026.10.10
            </span>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
              91下载官网与<span className="text-primary-600">最新地址</span>入口，一处集中汇总
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              本页汇集91下载官网入口、可用网址与官方app下载方式，把主站、备用线路和各类客户端整理成一份随时可查的入口索引。首次访问或老用户换新地址，都能在这里一步直达，不用再四处翻找。
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#entry"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600 md:text-base"
              >
                <i className="ri-links-line" />
                前往入口索引
              </a>
              <a
                href="#lines"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-3 text-sm text-foreground-900 transition-colors hover:bg-background-200 md:text-base"
              >
                <i className="ri-pulse-line" />
                查看线路状态
              </a>
            </div>
            <dl className="mt-9 grid grid-cols-2 gap-5 border-t border-background-200 pt-6 sm:grid-cols-4 md:gap-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    {stat.value}
                    <span className="ml-1 text-sm font-normal text-foreground-500">{stat.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <div className="relative aspect-[9/11] w-full overflow-hidden rounded-xl border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20of%20an%20app%20download%20concept%20with%20floating%20rounded%20cards%20and%20downward%20arrows%2C%20warm%20orange%20and%20vermillion%20gradient%20shapes%20on%20a%20soft%20cream%20background%2C%20isometric%20stylized%20modern%20editorial%20style%2C%20clean%20composition%2C%20no%20text&width=900&height=1100&seq=91down-hero&orientation=portrait"
                alt="91下载官网入口、最新地址与官方app下载汇总示意"
                title="91下载入口索引与app下载"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="mt-4 flex items-center justify-between rounded-lg border border-background-200 bg-background-100 px-4 py-3">
              <span className="text-xs text-foreground-600 md:text-sm">
                主线路延迟稳定，推荐优先使用
              </span>
              <a href="#lines" className="cursor-pointer whitespace-nowrap text-xs text-primary-700 md:text-sm">
                详情 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}